/* global axios */
import ApiClient from './ApiClient';

class DataCollectionReportsAPI extends ApiClient {
  constructor() {
    super('data_collection_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, {
      params: this.buildParams(params),
    });
  }

  getCustomers(params = {}) {
    return axios.get(`${this.url}/customers`, {
      params: this.buildParams(params),
    });
  }

  getFields() {
    return axios.get(`${this.url}/fields`);
  }

  downloadCustomers({ fileType = 'xlsx', ...params } = {}) {
    return axios.get(`${this.url}/export`, {
      params: { ...this.buildParams(params), file_type: fileType },
      responseType: 'blob',
    });
  }

  // eslint-disable-next-line class-methods-use-this
  buildParams(params) {
    return {
      since: params.since,
      until: params.until,
      group_by: params.groupBy,
      status: params.status,
      search: params.search,
      field_ids: params.fieldIds,
      inbox_ids: params.inboxIds,
      team_ids: params.teamIds,
      assignee_ids: params.assigneeIds,
      label_ids: params.labelIds,
      sort_by: params.sortBy,
      sort_direction: params.sortDirection,
      page: params.page,
      per_page: params.perPage,
    };
  }
}

export default new DataCollectionReportsAPI();
